import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  button: {
    paddingLeft: theme.spacing(2)
  },
  container: {
    display: 'flex',
    marginRight: theme.spacing(2)
  },
  bannerText: {
    fontWeight: theme.typography.fontWeightMedium
  },
  link: {
    textDecoration: 'none'
  }
}));

export const useStickyHeaderStyles = makeStyles(theme => ({
  root: {
    boxShadow: theme.shadows[1],
    marginBottom: theme.spacing(1)
  }
}));

export default useStyles;
